const SearchConfig = (destination: any) => {
    return [
        {
            namespace: destination + '_searchValue',
            destination: destination,
            input: [
                {
                    id: 'search_name',
                    translation: 'Nach Rechnung suchen',
                    param: 'companyName',
                    method: 'like'
                }
            ],
            button: ['common.search', 'common.del.search', 'Neue Rechnung Anlegen']
        }
    ]
}

export default SearchConfig
